import { format, parseISO } from 'date-fns'

import { EMPTY_LIST } from '../../../constants/common'
import { DATE_API_DATA_FORMAT_SHORT } from '../../../constants/date'
import {
  toUkTimezoneDate,
  transposeToUkTimezoneDate,
} from '../../../utils/date'

import {
  CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE,
  CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS,
} from './CalendarRelieveDayModal.constants'

function getIsCalendarRelieveDaySameDay({ day, timezone, values }) {
  return getCalendarRelieveDayTargetDate({ timezone, values }) === day
}

function getCalendarRelieveDayRequestIds({ followUps, values }) {
  const selectedIds = values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS]

  return followUps
    .filter(followUp => selectedIds.includes(followUp.id))
    .map(followUp => followUp.requestId)
}

export function getCalendarRelieveDayInitialValues({ nextFreeDay, timezone }) {
  return {
    [CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE]: nextFreeDay?.date
      ? transposeToUkTimezoneDate(parseISO(nextFreeDay.date), timezone)
      : null,
    [CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS]: EMPTY_LIST,
  }
}

export function getCalendarRelieveDayTargetDate({ timezone, values }) {
  const date = values[CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE]

  return date
    ? format(toUkTimezoneDate(date, timezone), DATE_API_DATA_FORMAT_SHORT)
    : null
}

export function getCalendarRelieveDayTargetLoadParams({
  day,
  followUps,
  timezone,
  values,
}) {
  const date = getCalendarRelieveDayTargetDate({ timezone, values })

  return {
    date: date === day ? null : date,
    requestIds: getCalendarRelieveDayRequestIds({ followUps, values }),
  }
}

export function getCalendarRelieveDayPayload(values, timezone) {
  return {
    date: getCalendarRelieveDayTargetDate({ timezone, values }),
    ids: values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS],
  }
}

export function getIsCalendarRelieveDayLoading(nextFreeDay) {
  return !nextFreeDay
}

export function getIsCalendarRelieveDayPending({ isLoading, targetLoad }) {
  return isLoading || targetLoad.isLoading
}

export function getIsCalendarRelieveDaySubmitDisabled({
  day,
  isPending,
  timezone,
  values,
}) {
  return (
    isPending ||
    values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS].length === 0 ||
    !values[CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE] ||
    getIsCalendarRelieveDaySameDay({ day, timezone, values })
  )
}
